// extracted by mini-css-extract-plugin
module.exports = {"edit":"index_edit_4wapn","save":"index_save_3ZTkb","cancel":"index_cancel_1XP7L"};